import api from './api';

// Kept out of lib/api.js and lib/api/*.js deliberately, same posture as
// lib/adminReceiptPaidNoCandidateAutopsyApi.js (this card's own backend
// route file, routes/admin_receipt_paid_no_candidate_autopsy.py, mounts
// both): DiagnosticsPage.jsx is edited concurrently by other sessions, and
// this is the only call site this card needs.
//
// Single out-of-band action (202 + job id, JobStore-backed, own operation
// key separate from the sibling autopsy job) -- see services/single_token_
// containment_audit.py for what it classifies.
export const adminSingleTokenContainmentAuditAPI = {
  start: (mode) => api.post(
    '/admin/diagnostics/single-token-containment-audit/start', null, { params: mode ? { mode } : {} },
  ),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/single-token-containment-audit/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/single-token-containment-audit/job-latest'),
};
